module.exports = __webpack_public_path__ + "img/slolution-3.98ce2b8.png";